import React, { useContext, useEffect, useState } from 'react';
import Header from './components/shared/Header/Header';
import Footer from './components/shared/Footer/Footer';
import Routes from './route/Routes';
import { authContext } from '../src/provider/Context/AuthContext';
import { userContext } from '../src/provider/Context/UserContext';
import UserDetails from './common/model/UserDetails';
import { ToastContainer } from 'react-toastify';
import DIContainer from "../src/config/di.container";
import DITYPES from "../src/config/di.types";
import ToastrService from "../src/services/ToastrService";
import { useLocation } from 'react-router';
import { EOnBoardingStatusEnum } from './common/enum/EOnBoardingStatusEnum';

import { useHistory } from "react-router-dom";
import LoggedInUserInfo from './common/model/LoggedInUserInfo';
import { snackBarClose, snackBarOpen, userDetailsLocalStorageKey } from './common/constant';
import LocalStorageService from './services/local.storage.service';
import './styles/styles.css';
import LoaderContainer from './components/shared/Loader/LoaderContainer';
import NotificationService from './services/NotificationService';
import { EAccountStatus } from './common/enum/EAccountStatus';
import EventEmitter from "./config/event.emitter"
import SnackbarContext from './provider/Context/SnackbarContext';
import { SnackbarModel } from './common/model/SnabarModel';


let toastrService: ToastrService = DIContainer.get<ToastrService>(DITYPES.ToastrService);
const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);
const notificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);


export interface IAppProps {
  isLoggedIn: boolean;
  userDetails: UserDetails;
  AccountStatus: EAccountStatus;
}
const App: React.FC<IAppProps> = (props) => {
  const history = useHistory();
  const baseOnboardingpath = "ui/onboarding";

  const IsAPIHeader = () => {
    let route = window.location.href.split("/").pop();
    return route?.includes("onboarding");
  };

  //Setting Context//
  const { setAuthData } = useContext(authContext);
  const { setUserDetails } = useContext(userContext);
  const auth = useContext(authContext);
  const { displayMsg, onClose } = useContext(SnackbarContext)
  const user = useContext(userContext);
  const [canAppendShowCSS, setheaderCss] = React.useState(false);
  const [nameInitials, setNameInitials] = useState("")

  useEffect(() => {    
    setResetHTMLHeight();
    snackBarEventListner();
  }, [])

  const setResetHTMLHeight = () =>{
    if (window?.location.pathname.indexOf('documentation') > -1){
      document.getElementsByTagName("html")[0].style.height = "85%";
        }
      else{
        document.getElementsByTagName("html")[0].removeAttribute("style");
      }
  }

  const snackBarEventListner = () => {
    const openSnackBarEvent = EventEmitter.addListener(snackBarOpen, showSnackBar);
    const closeSnackBarEvent = EventEmitter.addListener(snackBarClose, closeSnackbar);

    return () => {
      openSnackBarEvent.removeAllListeners();
      closeSnackBarEvent.removeAllListeners();
    }
  }

  const showSnackBar = (eventData: SnackbarModel) => {
    displayMsg(eventData?.Message, eventData?.Name);
  }
  const closeSnackbar = () => {
    onClose();
  }

  useEffect(() => { 
    var userInfo = new LoggedInUserInfo();
    userInfo.isLoggedIn = props.isLoggedIn;
    userInfo.status = props.userDetails.AccountStatus;

    setAuthData(userInfo);
    localStorageService.set(userDetailsLocalStorageKey, JSON.stringify(props.userDetails));
    setUserDetails(props.userDetails);
    settingNameInitials();
  }, [props.userDetails])
  let location = useLocation();

  let locationState: any = location.state || {
    from: { pathname: "/" }
  };

  useEffect(() => {
    loadOnBoarding();
  }, [auth])

  const settingNameInitials = () => {
    if (!props?.userDetails.NameInitials && props?.userDetails?.FirstName && props?.userDetails?.LastName) {
      setNameInitials(`${props?.userDetails?.FirstName?.charAt(0)}${props?.userDetails?.LastName?.charAt(0)}`);
    }
    else if(props?.userDetails.NameInitials){
      setNameInitials(props?.userDetails.NameInitials);
    }
  }

  const loadOnBoarding = () => {
    if (auth.loggedIn && locationState?.from.pathname != "/" && Object.values(EOnBoardingStatusEnum).includes(EOnBoardingStatusEnum[String(auth?.status)])) {
      history.push(locationState.from.pathname)
    }
    if (auth.loggedIn && Object.values(EOnBoardingStatusEnum).includes(EOnBoardingStatusEnum[String(auth?.status)]) && (auth.loggedIn == true && (history.location.pathname.includes("/ui/onboarding") || history.location.pathname == "/ui"))) {
      if (auth.status && Object.values(EOnBoardingStatusEnum).includes(EOnBoardingStatusEnum[String(auth?.status)])) {
        if (!history.location.pathname.includes("ui/onboarding")) {
          history.push(`${baseOnboardingpath}`)
        }
      }
      else if (auth?.status?.valueOf() == 0 && !history.location.pathname.includes(`${baseOnboardingpath}/create-account`)) {
        history.push(`${baseOnboardingpath}/create-account`);
      }
    }
  }
  return (
    <div>
      <div>
        <Header
          canAddCssShow={canAppendShowCSS}
          LoggedIn={props.isLoggedIn}
          AccountStatus={props.userDetails.AccountStatus}
          NameInitials={nameInitials}
          AdminSourceId ={props.userDetails.AdminSourceId}
        />
      </div>
      <LoaderContainer />
      <div
        onClick={() => {
          setheaderCss(!canAppendShowCSS);
        }}
      >
        <ToastContainer />
        <Routes></Routes>
        <Footer LoggedIn={props.isLoggedIn} />
      </div>
    </div>
  );
}
export default App;